

let pointerFrom = 0;
let elementFrom = 0;

const scrollable = document.getElementById('wrapper56468');
if (scrollable) {

    const onDrag = (event) => {
        if (event.pointerType == 'mouse') {
            scrollable.scrollLeft = elementFrom - event.clientX + pointerFrom;
        }
    };

    scrollable.addEventListener('pointerdown', (event) => {
        if (event.pointerType == 'mouse') {
            pointerDown = true;
            // Set the position where the mouse is starting to drag from.
            pointerFrom = event.clientX;
            // Set the position of the element is scrolled from.
            elementFrom = scrollable.scrollLeft;

            // React on pointer move.
            document.addEventListener('pointermove', onDrag);
        }
    });

    // Stop reacting on pointer move when pointer is no longer clicked.
    document.addEventListener('pointerup', (event) => {
        if (event.pointerType == 'mouse') {
            document.removeEventListener('pointermove', onDrag);
        }
    });
}

isMobile();
window.addEventListener('resize', function () {
    isMobile();
})

function isMobile() {
    // window.isMobileScreen = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    window.isMobileScreen = (() => {
        // Check screen width first (common breakpoint for mobile devices is 768px or less)
        const isSmallScreen = window.innerWidth <= 768;
    
        // Use user-agent as a secondary check
        const isMobileUserAgent = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
        // Combine conditions: prioritize screen width, fallback to user-agent
        return isSmallScreen || (isMobileUserAgent && window.innerWidth <= 1024); // Adding a threshold for tablets
    })();
}